import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as moment from "moment";
moment.locale("pt-br");

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable()
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { inventario: worksheet },
      SheetNames: ["inventario"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + "_" + moment().format("YYYYMMDDhhmm") + EXCEL_EXTENSION
    );
  }

  static saveFromResponse(response) {
    const blob = new Blob([response.body], {
      type: response.headers.get("content-type"),
    });
    const file = new File([blob], response.headers.get("X-Filename"), {
      type: response.headers.get("content-type"),
    });
    FileSaver.saveAs(file);
  }
}
